import { doLogin, doLogout, setInitInfo } from './actions';
import { push } from 'connected-react-router';
import axios from 'axios';

//ログイン処理
const loginOperation = () => {
  return async(dispatch, getState) => {
    dispatch(doLogin());
  };
};

//ログイン者情報取得
const getLoginInfoOperation = () => {
  return async(dispatch, getState) => {

    console.log('------getLoginInfoOperation------');
    // cognito
    const header = {'Authorization' : localStorage.idToken}

    const param = {
      'employeeAccount' : localStorage.username
    };
    console.log('param', param);

    return await axios.get('login',{
      params:param,
      headers:header
    });
  };
};

//初期情報取得
const getInitInfoOperation = () => {
  return async(dispatch, getState) => {

    console.log('------getInitInfoOperation------');
    // cognito
    const header = {'Authorization' : localStorage.idToken}
    const param = {};

    return await axios.get('init',{
      params:param,
      headers:header
    });
  };
};

//初期情報セット
const setInitInfoOperation = (res) => {
  console.log('------setInitInfoOperation------');
  return (dispatch, getState) => {
    console.log('res', res);
    dispatch(setInitInfo(res.data.resultList[0]));
  };
};

const logoutOperation = () => {
  console.log('------logoutOperation------');
  return (dispatch, getState) => {
    dispatch(push("/"));
    dispatch(doLogout());
    localStorage.clear();
  };
};

export default {
  loginOperation,
  getLoginInfoOperation,
  getInitInfoOperation,
  setInitInfoOperation,
  logoutOperation,
};
